<div class="px-6 py-4 border-b border-gray-100 bg-white flex items-center gap-3">
  <span class="h-10 w-10 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center flex-shrink-0"><mat-icon>do_not_disturb_on</mat-icon></span>
  <div>
    <h1 class="text-xl font-bold text-gray-900 leading-tight">Reject this request</h1>
    <p class="text-xs text-gray-500">{{ data?.name }}{{ data?.email ? ' · ' + data.email : '' }}</p>
  </div>
</div>
<div class="px-6 py-5">
  <p class="text-sm text-gray-600">The applicant is emailed this reason, so keep it clear and polite.</p>

  <div class="mt-3 flex flex-wrap gap-2">
    @for (t of templates; track t.label) {
    <button type="button" class="px-3 py-1.5 rounded-full border border-gray-200 bg-white text-xs font-semibold text-gray-600 hover:border-amber-300 hover:bg-amber-50 transition-colors" (click)="useTemplate(t.text)">{{ t.label }}</button>
    }
  </div>

  <div class="mt-4">
    <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider" for="reject-reason">Reason *</label>
    <textarea id="reject-reason" rows="5"
      class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm"
      name="reject-reason" placeholder="Explain why the request was not approved" [(ngModel)]="rejectReason" required #rejectReasonInput="ngModel"></textarea>
    @if (rejectReasonInput.invalid && (rejectReasonInput.dirty || rejectReasonInput.touched)) {
    <div class="mt-1 text-xs text-red-500">Reject reason is required</div>
    }
  </div>
</div>
<div class="px-6 py-4 border-t border-gray-100 bg-white flex flex-row justify-end gap-3">
  <button type="button" class="px-5 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors" (click)="onCancel()">Cancel</button>
  <button type="button" [disabled]="!rejectReason.trim()" (click)="onRejectClick()"
    class="px-6 py-2.5 rounded-xl bg-gradient-to-b from-rose-500 to-rose-600 text-white font-bold text-sm shadow-md shadow-rose-200 hover:from-rose-400 hover:to-rose-500 active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none">Reject and email</button>
</div>
